import { useEffect } from 'react';
import { bootUpChat, setupChat } from '../methods/client';

function useChat(config: Partial<Window['intercomSettings']>, isAgent = false) {
  useEffect(() => {
    if (!isAgent) {
      setupChat(config?.app_id);
      bootUpChat(config);
    }
  }, []);
}

export { useChat };
